<template>
	<div class="log-search-body">
		<div class="filters-box-row" :style="collapse ? 'height: 50px' : ''">
			<div class="filters-container">
				<div class="input-box">
					<el-date-picker
						@change="searchTime"
						v-model="dateValue"
						:clearable="false"
						:unlink-panels='true'
						class="time-input"
						size="small"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span class="input-title">操作人：</span>
					<el-input
						class="search-input"
						v-model="operator"
						placeholder="请输入操作人"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span class="input-title">联系方式：</span>
					<el-input
						class="search-input"
						v-model="tel"
						placeholder="请输入联系方式"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span class="input-title">操作对象：</span>
					<el-input
						class="search-input"
						v-model="operationObject"
						placeholder="请输入操作对象"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span class="input-title">操作类型：</span>
					<el-input
						class="search-input"
						v-model="operationType"
						placeholder="请输入操作类型"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span class="input-title">详情：</span>
					<el-input
						class="search-input detail"
						v-model="operationDetail"
						placeholder="请输入详情"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
		</div>
		<div class="log-search-btn">
			<el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
			</el-button>
			<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
			<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	components: {
		// Print
	},
	props: {
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			dateValue: [],
			operator: '',
			tel: '',
			operationObject: '',
			operationType: '',
			operationDetail: '',
			collapse: false
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '7-6')
		// if (window.sessionStorage.getItem('logSearchTime')) {
		// 	this.dateValue = JSON.parse(window.sessionStorage.getItem('logSearchTime'))
		// } else {
		this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
		// }
	},
	methods: {
		handleCollapse () {
			this.collapse = !this.collapse
		},
		searchTime (value) {
			window.sessionStorage.setItem('logSearchTime', JSON.stringify(value))
		},
		clear () {
			let value = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.searchTime(value)
			this.clearAllInput()
			this.search()
		},
		clearAllInput () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.operator = ''
			this.tel = ''
			this.operationObject = ''
			this.operationType = ''
			this.operationDetail = ''
		},
		search () {
			console.log(this.dateValue)
			this.$emit('handleSearch', { dateValue: this.dateValue, operator: this.operator, tel: this.tel, operationObject: this.operationObject, operationType: this.operationType, operationDetail: this.operationDetail })
		}
	}
}
</script>

<style lang="stylus" scoped>
.log-search-body {
	display: flex;
	justify-content: space-between
	padding: 10px;
	width :100%;
	line-height :50px;
	.log-search-btn {
		width: 200px;
		flex-shrink: 0
	}
	.filters-box-row {
		display: flex;
		flex-wrap: wrap;
		overflow: hidden
		box-sizing: border-box
		text-align: left
		.search-input {
			width: 200px!important;
		}
		.input-title {
			display: inline-block;
			text-indent: 1em
		}
	}
}
</style>
<style lang="stylus">

</style>
